import { useRef, useCallback, forwardRef, memo, useState } from 'react';
import styles from './FJAudioPlay.module.less';
import FJPauseIcon from '../../../../assets/svg/pause-black.svg?react';
import FJPlayIcon from '../../../../assets/svg/play-black.svg?react';
import FJAudioWaveImgUpload from '../../FJAudioWave/FJAudioWaveImgUpload.jsx';
import FJUtil from '../../../../util/FJUtil.js';
import FJButton from '../../FJButton/FJButton.jsx';
import FJDeleteIcon from '../../../../assets/svg/delete-black.svg?react';
import FJTextWithEllipsis from '../../FJTextWithEllipsis/FJTextWithEllipsis.jsx';

const FJAudioPlay = (props, ref) => {
    const { audioUrl, type, audioName, deleteAudio, isOnlyPreview = false } = props;
    const [isPlay, setIsPlay] = useState(false);
    const audioRef = useRef(null);
    const [audioDuration, setAudioDuration] = useState(null);

    const updateDuration = useCallback(duration => {
        setAudioDuration(FJUtil.formatTime(duration, false, 2));
    }, []);

    const _changePlay = e => {
        e.stopPropagation();
        try {
            if (audioRef.current.isLoaded()) {
                setIsPlay(!isPlay);
                if (isPlay) {
                    audioRef.current.pause();
                } else {
                    audioRef.current.play();
                }
            }
        } catch (e) {}
    };
    return (
        <div className={styles.box}>
            {!isOnlyPreview && (
                <div className={styles.header}>
                    <FJTextWithEllipsis className={styles.name} text={audioName} />
                    <div className={styles.time}>{audioDuration}</div>
                </div>
            )}
            <div className={styles.wave_box}>
                <div className={styles.control} onClick={_changePlay}>
                    {isPlay && <FJPauseIcon />}
                    {!isPlay && <FJPlayIcon />}
                </div>
                <div className={styles.audio_box}>
                    <FJAudioWaveImgUpload
                        url={audioUrl}
                        ref={audioRef}
                        setIsPlay={setIsPlay}
                        updateDuration={updateDuration}
                        isPlay={isPlay}
                        config={{ width: 335, height: 24 }}
                    />
                </div>
                {isOnlyPreview ? (
                    <div className={styles.time} style={{ marginLeft: '20px' }}>
                        {audioDuration}
                    </div>
                ) : (
                    <FJButton
                        type='white'
                        icon={<FJDeleteIcon />}
                        className={styles.delete_icon}
                        onClick={deleteAudio}
                    />
                )}
            </div>
        </div>
    );
};

export default memo(forwardRef(FJAudioPlay));
